import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import DataTable from '../../../../Common/DataTable';
import { RootState } from '../../../../redux/rootState';
import { setLoader } from '../../../../redux/loaderSlice';
import ComponentDeleteModal from '../../../../Common/DeleteModal/ComponentDeleteModal';
import ComponentEquipmentCategoryListDialog from './ComponentEquipmentCategoryListDialog';
import { deleteEquipmentCategoryListStart, getEquipmentCategoryListStart } from '../redux/sliceEquipmentCategoryList';
import { EquipmentCategoryList } from '../utils/types';

function ComponentEquipmentCategoryListTable() {
  const [open, setOpen] = useState(false);
  const [rowId, setRowId] = useState('');
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedEquipmentCategoryListId, setSelectedEquipmentCategoryListId] = useState<string>('');
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [searchQuery, setSearchQuery] = useState('');
  const dispatch = useDispatch();

  const { isLoading, EquipmentCategoryListData } = useSelector((state: RootState) => state.ListEquipmentCategoryReducer);
  const { showDeleteIcon } = useSelector((state: RootState) => state.masterDataReducer);

  const handleData = () => {
    const params = {
      page,
      rowsPerPage,
      searchQuery,
    };
    dispatch(getEquipmentCategoryListStart(params));
  };

  const handleAction = (id: string) => {
    setOpen(true);
    setRowId(id);
  };

  const handleButtonClick = () => {
    setRowId('');
    setOpen(!open);
  };

  useEffect(() => {
    dispatch(setLoader(isLoading));
  }, [isLoading]);

  const TableColumns = useMemo(
    () => [
      // { key: 'sn', label: 'SN' },
      { key: 'action', label: 'Action' },
      { key: 'Category', label: 'Category' },
    ],
    [],
  );

  const tableData: EquipmentCategoryList[] = useMemo(() => EquipmentCategoryListData?.Data?.map((item, index) => {
    const transformedDataItem = {
      sn: index,
      action: showDeleteIcon ? 'edit&delete' : 'edit',
      Category: item?.Description,
      id: String(item?.Id),
    };
    return transformedDataItem;
  }), [EquipmentCategoryListData]);

  const handleDelete = (id: string) => {
    setShowDeleteModal(true);
    setSelectedEquipmentCategoryListId(id);
  };

  const handelDeleteModal = () => {
    const paramData = {
      Id: selectedEquipmentCategoryListId,
      page,
      rowsPerPage,
      searchQuery,
    };
    dispatch(deleteEquipmentCategoryListStart(paramData));
    setShowDeleteModal(false);
  };

  return (
    <>
      <DataTable<EquipmentCategoryList>
        handleButtonClick={handleButtonClick}
        data={tableData}
        columns={TableColumns}
        totalRecords={EquipmentCategoryListData?.TotalRecords}
        buttonText="Add"
        page={page}
        setPage={setPage}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}
        searchQuery={searchQuery}
        setSearchQuery={setSearchQuery}
        handleData={handleData}
        handleEdit={handleAction}
        handleDelete={handleDelete}
      />
      <ComponentEquipmentCategoryListDialog show={open} setOpenFrom={handleButtonClick} rowId={rowId} handleData={handleData} />
      <ComponentDeleteModal
        show={showDeleteModal}
        setOpenFrom={() => setShowDeleteModal(false)}
        handleDelete={handelDeleteModal}
      />
    </>
  );
}

export default ComponentEquipmentCategoryListTable;
